import React, { useState, useEffect } from 'react'
import {
	DndContext,
	closestCenter,
	KeyboardSensor,
	PointerSensor,
	useSensor,
	useSensors,
} from '@dnd-kit/core'
import {
	arrayMove,
	SortableContext,
	sortableKeyboardCoordinates,
	verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { useContext } from 'react'
import { ProductContext } from './../../../store'
import { PostData } from '../../../services/FetchData'
import { toast } from 'react-toastify'
import { Spinner } from 'reactstrap'

const EditFilterSettings = ({updateFlag}) => {
	const { applySortingToValues, currentFilter: filter, setCurrentFilter, currentWebsiteId } = useContext(ProductContext)
	const [formData, setFormData] = useState({
		sortBy: filter.sortBy || 'default',
		appearance: filter.appearance,
		filterIds: filter.filterIds
	})
	const [saveLoader, setSaveLoader]	= useState(false)

	const handleInputChange = (field, value) => {
		setFormData(prev => ({
			...prev,
			[field]: value
		}))
	}

	const handleSave = () => {
		setSaveLoader(true)
		PostData("ms1", "api/v1/filters/updateFilterData", { websiteId: currentWebsiteId, filterId: filter.filterId, updateObj: { ...formData } }).then(response => {
			if( response !== "Invalid" && response !== "undefined" ){
				if( response.status === "success" ){
					setCurrentFilter({
						...filter,
						...formData
					})
					updateFlag()
				}else{
					toast.error(response.message??response.message.message)
				}
			}
			setSaveLoader(true)
		})
	}

	return (
		<div className="editFilterSettings">
			{/* Apply Changes Button - Top Right */}
			<div className="editFilterFormActions">
				<button
					className="editFilterSaveButton"
					onClick={handleSave}
					disabled={saveLoader}
				>
					{saveLoader ? <><Spinner size={"sm"} /> Applying ...</> : <>Apply changes</>}
				</button>
			</div>

			<div className="editFilterSettingsContent">
				{/* Form Fields */}
				<div className="editFilterFormRow">
					<label>Sort values by:</label>
					<select
						value={formData.sortBy}
						onChange={(e) => handleInputChange('sortBy', e.target.value)}
						className="editFilterSelect"
					>
						<option value="default">Default</option>
						<option value="nameAsc">Name(asc)</option>
						<option value="nameDesc">Name(desc)</option>
						<option value="manual">Manual</option>
					</select>
				</div>

				<div className="editFilterFormRow">
					<label>Appearance:</label>
					<select
						value={formData.appearance}
						onChange={(e) => handleInputChange('appearance', e.target.value)}
						className="editFilterSelect"
					>
						<option value="default">Default</option>
						<option value="color">Color</option>
						<option value="size">Size</option>
						<option value="image">Image swatch</option>
					</select>
				</div>

			</div>
		</div>
	)
}

export default EditFilterSettings
